import styled from "styled-components";

import ChecklistItemStatus from "../../../../../models/checklist/checklist-item/checklist-item-status";
import { Summary } from "features/shared/styles/typography/Summary.styled";

interface StyledCardProps {
  highlight?: boolean;
  status: ChecklistItemStatus;
}

const StyledCard = styled.div<StyledCardProps>`
  position: relative;
  overflow: hidden;
  background-color: ${({ theme }) => theme.colors.baseWhite};
  height: ${({ status }) =>
    status === ChecklistItemStatus.Resolved ? "auto" : "300px"};
  min-width: 295px;
  padding: 16px;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  box-shadow: ${({ theme }) => theme.shadows.card};
  border-radius: ${({ theme }) => theme.borderRadiusChecklistCard};
  border: 1px solid ${({ theme }) => theme.colors.base3};

  &::after {
    display: ${({ highlight }) => (highlight ? "block" : "none")};
    content: "";
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    height: 5px;
    background-color: ${({ theme }) => theme.colors.cardHighlighter};
  }

  ${Summary} {
    font-weight: 600;
  }
`;

export default StyledCard;
